module.exports = __webpack_public_path__ + "static/media/jobbeurs_home3_resize.eb8338cc.jpg";